import { render, staticRenderFns } from "./MessageFilterAdder.vue?vue&type=template&id=4a2e762a"
import script from "./MessageFilterAdder.vue?vue&type=script&lang=js"
export * from "./MessageFilterAdder.vue?vue&type=script&lang=js"
import style0 from "./MessageFilterAdder.vue?vue&type=style&index=0&id=4a2e762a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports